import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Select} from "antd";
import { API_TXALERT} from "../config/config";

const { Option } = Select;
const DATA_ALERT_PROVIDER_URL = API_TXALERT + "/provider";


const ProviderList = (props) => {

    const [data, setData] = useState([]);

    const fetchdata = useCallback(async() => {
        try{
        
            const response = await axios.post(
                DATA_ALERT_PROVIDER_URL,
                {},
                { headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") } }
            );           
            setData(response.data);
        } catch (error) {
          return ( { data: false });
        }      

    }, []);

    useEffect(() => {
        fetchdata();
    }, [fetchdata]);



    const getProvider = () => {       
        
            return data.map((item) => (               
                    <Option key={item.dataIndex} value={item.alertproviderid}>
                        {item.title }
                    </Option>                    
            ))
        
    };
    
    return (
        
        <Select 
            showSearch
            mode="multiple"
            showArrow="true"
            maxTagCount="responsive"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
            {...props}
            >    {data.length > 0
            ? getProvider()
            : null}</Select>
    );
};

export default ProviderList;